import { render, staticRenderFns } from "./QOL-AD.vue?vue&type=template&id=50d5ff12&scoped=true&"
import script from "./QOL-AD.vue?vue&type=script&lang=js&"
export * from "./QOL-AD.vue?vue&type=script&lang=js&"
import style0 from "./QOL-AD.vue?vue&type=style&index=0&id=50d5ff12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d5ff12",
  null
  
)

export default component.exports